export default class Pluralizer
{

  constructor(count, singular, plural) {
    this.count = 1 * count;
    this.singular = singular;
    this.plural = plural;
  }

  toString() {
    return this.count + ' ' + (this.count === 1 ? this.singular : this.plural);
  }
}
